import { Navigate } from "react-router";
import { useAuth } from "../context/AuthContext";
import type { UserRole } from "../types";

interface AdminRouteProps {
  children: React.ReactNode;
  /** Roles allowed to access this route. Defaults to ORG_ADMIN + ADMIN. */
  allowedRoles?: UserRole[];
}

/**
 * Route guard that redirects unauthenticated users to /login
 * and unauthorized users to /unauthorized.
 */
export function AdminRoute({
  children,
  allowedRoles = ["ORG_ADMIN", "ADMIN"],
}: AdminRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
}
